import styled from "styled-components";
import { theme } from "@themes";

export const GeneralStyle = styled.div`
  background-color: ${({ colorPickerPreview }) => colorPickerPreview};
  background-image: url(${({ backgroundPreview }) => backgroundPreview});
  padding: 1rem;
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};

  h1 {
    text-align: center;
    color: ${({ theme }) => theme.primaryLight};
    padding: 20px 15px;
    color: ${({ theme }) => theme.primary.purple};
  }

  footer {
    color: ${({ theme }) => theme.button.primary};
    align-self: center;
    text-align: center;
    font-weight: bold;
  }

  .title-field {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .public-DraftEditorPlaceholder-root {
    color: #dbd4da;
    font-size: 26px;
    width: 100%;
    text-align: center;
    font-weight: 700;
  }

  .wrapper-class {
    background-color: transparent !important;
    border: none !important;
  }

  .wrapper-class:focus-within {
    background-color: ${({ theme }) => theme.neutral.white} !important;
    border: 1px solid ${({ theme }) => theme.neutral.gray[200]} !important;
  }

  .editor-class {
    height: 100% !important;
    overflow: initial;
  }
`;

export const ButtonSubmit = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.button.primaryBorder};
  background-color: transparent;
  border-radius: 4px;
  color: ${({ theme }) => theme.button.primaryBorder};
  width: 12em;
  height: 40px;
  font-size: 13px;
  margin-right: 10px;
  &:hover {
    box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.secondaryPurple};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;

export const BlockWrapper = styled.div`
  display: grid;
  ${({ isDependent }) => isDependent && `margin-left: 5em;`}
  grid-template-columns: 1fr;
  grid-auto-rows: 1fr 1px;
  grid-template-columns: minmax(80%, 710px);
  justify-content: center;
  svg {
    cursor: pointer;
    width: 27%;
    justify-self: center;
    height: 27%;
  }
`;
export const StyledButton = styled.button`
  align-self: center;
  justify-self: center;
  margin-bottom: 0.5rem;
  margin-top: 2em;
  margin-right: 0.4em;
  width: ${({ style }) => (style && style.fontSize === 14 ? "8rem" : "auto")};
  height: ${({ style }) => (style && style.fontSize === 14 ? "2rem" : "auto")};
  outline: 0;
  padding: 6px 12px;
  color: ${({ theme }) => theme.neutral.white};
  border-radius: 3px;
  border: none;
  margin-top: 2em;
  background: ${({ theme }) => theme.button.primary};
  transition: transform 0.1s ease;
  min-width: 100px;
  &:hover {
    box-shadow: 0px 4px 20px 0px
      ${({ style, theme }) =>
        style ? style.backgroundColor : theme.secondaryPurple};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;
export const StyledButtonCancel = styled.button`
  align-self: center;
  justify-self: center;
  margin-right: 0.4rem;
  width: 8rem;
  height: 2rem;
  outline: 0;
  padding: 6px 12px;
  color: ${({ theme }) => theme.secondaryPurple};
  margin-top: 20px;
  border-radius: 3px;
  border: 1px solid ${({ theme }) => theme.secondaryPurple};
  background: ${({ theme }) => theme.primaryBackgroundLight};
  transition: transform 0.1s ease;
  &:hover {
    box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.secondaryPurple};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;

export const StyledButtonGenericQuestion = styled.button`
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  margin-right: 0.6rem;
  width: 5rem;
  height: 2rem;
  outline: 0;
  color: ${({ theme }) => theme.secondaryPurple};
  margin-top: 20px;
  padding: 0;
  border: none;
  background: none;
  border-right: ${({ lastElement }) =>
    !lastElement ? "1px solid #cccc" : "none"};
  transition: transform 0.1s ease;
  vertical-align: middle;
  &:hover {
    cursor: pointer;
  }

  svg {
    width: 18px;
    height: 21px;
    margin-right: 5px;
  }
`;

export const ContainerLogo = styled.div`
  display: flex;
  justify-content: ${({ positionLogoPreview }) => positionLogoPreview};
  padding: 25px;
`;
// width: 200px;
export const SurveyQuestionConfigurationContainer = styled.div`
  border-bottom: 1px solid #c3c1c1;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TitlePreview = styled.div`
  display: flex;
  justify-self: flex-start;
  justify-content: center;
  align-items: center;
  span {
    color: #8f9bb3;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 19px;
    font-family: ${({ theme }) => theme.secondaryFontFamilyTwo};
  }
`;

export const PreviewElements = styled.div`
  display: grid;
  justify-content: center;
  height: calc(80vh - 46px);
  overflow: auto;
  box-sizing: border-box;
  grid-template-columns: 100%;
  scrollbar-color: ${({ theme }) => theme.shadows.veryStrong} rgba(0, 0, 0, 0);
  scrollbar-width: thin;
  &::-webkit-scrollbar {
    -webkit-appearance: none;
  }
  &::-webkit-scrollbar:vertical {
    width: 10px;
  }
  &::-webkit-scrollbar:horizontal {
    height: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: gray;
    border-radius: 20px;
    border: 2px solid #f1f2f3;
  }
  &::-webkit-scrollbar-track {
    border-radius: 10px;
  }
`;

export const FooterElement = styled.div`
  padding: 15px;
  span {
    display: flex;
    justify-content: center;
    font-family: "Noto Sans", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: ${({ theme }) => theme.button.primary};
  }
`;
export const HeaderDependency = styled.div`
  max-width: 600px;
  padding: 0.4em;
  /*background:${({ childDependencies }) =>
    childDependencies == undefined ? "#0087FF" : `#${childDependencies}`}; */
  background: #0087ff;
  color: white;
  height: auto;
  border-radius: 5px;
  /* margin: auto; */
  margin-left: 6em;
  font-size: 16px;
  text-align: center;
  font-weight: 600;
`;
export const RightContent = styled.div`
  display: flex;
  align-items: center;
  svg {
    cursor: pointer;
  }
  svg > path {
    fill: ${({ theme }) => theme.primary.purple};
  }
`;
export const AlertContainer = styled.div``;

export const customStyles = {
  control: (base, state) => ({
    ...base,
    boxShadow: "none",
    borderColor: "#8F9BB3",
    fontSize: "14px",
    // You can also use state.isFocused to conditionally style based on the focus state
    "&:hover": {
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgb(0 123 255 / 25%)",
    },
  }),
};

export const FileUpload = styled.input`
  visibility: hidden;
  height: 0;
  width: 0;
`;

export const TitleAdditionalData = styled.p`
  font-weight: 700;
  font-size: 26px;
  text-align: center;
  color: ${({ theme }) => theme.primary.purple};
  width: 100%;
`;

export const ContentPreviewEmpty = styled.div`
  width: 100%;
  height: 532.32px;
  display: flex;
  justify-content: center;
`;
